import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const DesktopIcon: React.FC<IconProps> = ({ 
  width = 16, 
  height = 16, 
  className = "" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect 
        x="1" 
        y="3" 
        width="14" 
        height="9" 
        rx="1" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        fill="none"
      />
      <rect 
        x="6" 
        y="12" 
        width="4" 
        height="1" 
        rx="0.5" 
        fill="currentColor"
      />
      <line 
        x1="4" 
        y1="14" 
        x2="12" 
        y2="14" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};
